import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { config } from 'src/environments/environment'
import { ConsoleLogService } from '../services/console-log.service'
import { FileProcessingService } from '../services/file-processing.service'
import { MessageService } from 'primeng/api'

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  mediaUrl = config.mediaUrl
  noImage =
    'data:image/png;base64,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'
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private fileService: FileProcessingService,
    private consoleLogsServices: ConsoleLogService
  ) {}

  imageSuffixes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'svg', 'webp', 'jfif']

  // Detect image requests by extension, ignoring query strings / hashes and casing.
  // Blob image URLs (e.g. Azure) can carry SAS query params or uppercase extensions,
  // which a naive `url.endsWith(suffix)` check would miss.
  private isImageRequest(url: string): boolean {
    const path = url.split(/[?#]/)[0].toLowerCase()
    return this.imageSuffixes.some((suffix) => path.endsWith('.' + suffix))
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(async (error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.messageService.add({ severity: 'info', summary: 'Forbidden...', detail: request.url })
        } else if (error.status === 401) {
          this.messageService.add({ severity: 'info', summary: 'Unauthorized...', detail: request.url })
        }
        // Check if the request is for an image and if it returned a 404 error
        // console.log('request', request)
        // this.consoleLogsServices.addConsoleLog('HttpInterceptor', JSON.stringify({ request, error }), 'white', 'HttpInterceptor:30');
        if (request.responseType === 'blob' && error.status === 404 && this.isImageRequest(request.url)) {
          // Replace the error response with the placeholder image response
          // const placeholderImageUrl = '/assets/icon/no-image.png';

          // let img64 = await this.getBase64ImagefromUrl(placeholderImageUrl).toPromise();
          console.log('img64', this.noImage)
          const placeholderResponse = new HttpResponse({
            body: this.fileService.dataURItoBlob(this.noImage),
            status: 200, // You can also set other status codes here if needed
          })
          return placeholderResponse
        } else {
          // For other errors, just re-throw the error
          throw error
        }
      })
    )
  }
  // private getBase64ImagefromUrl(imageUrl: string): Observable<string> {
  //     //setup the http options including CORS
  //     let header = new HttpHeaders();
  //     header.set('Access-Control-Allow-Origin', '*');
  //     header.set('ngsw-bypass', '');

  //     const options = {
  //         HttpHeaders: header,
  //         observe: 'body' as const, //avoid 'body' being inferred as string
  //         //params: params,
  //         responseType: 'blob' as const, //avoid 'blob' being inferred as string
  //     };

  //     // get the blob from the provided imageurl
  //     return this.http.get(imageUrl, options).pipe(
  //         // use switchMap to avoid Observable of Observables
  //         switchMap((blobresponse) => {
  //             console.log('http get ', imageUrl, ' blob gives ', blobresponse);
  //             return this.readURL(blobresponse);
  //         })
  //     );
  // }
  public readURL = (blob: Blob): Observable<string> =>
    new Observable((obs) => {
      if (!(blob instanceof Blob)) {
        obs.error(new Error('`blob` must be an instance of File or Blob.'))
        return
      }

      const reader = new FileReader()
      // map the events from FileRead to observable methods
      reader.onerror = (err) => obs.error(err)
      reader.onabort = (err) => obs.error(err)
      reader.onload = () => obs.next(reader.result as string)
      reader.onloadend = () => obs.complete()

      return reader.readAsDataURL(blob)
      //return reader.readAsArrayBuffer(blob);
    })
}
